export const CERTIFICATE_STATUS_COLOR: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  ACTIVE: 'success',
  INACTIVE: 'warning',
  CANCELLED: 'error',
};

export const PROCESS_STATUS_COLOR: Record<string, 'success' | 'info' | 'warning' | 'error' | 'default'> = {
  FINISHED: 'success',
  PENDING: 'warning',
  IN_PROGRESS: 'info',
  FAILED: 'error',
};

export const CERTIFICATE_TYPE_LABELS: Record<string, string> = {
  FLIGHTS_ONLY: 'Flights-Only',
  PACKAGE_SINGLE_CONTRACT: 'Package',
};
